import { Address, Job } from '@kanda-libs/ks-frontend-services';

import { formatDate } from 'utils';

export interface BaseJobInfo {
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  customerAddress: string;
}

export interface FormattedJob extends BaseJobInfo {
  id: string;
  title: string;
  createdAt: string;
  updatedAt: string;
}

const formatAddress = (address?: Address): string => {
  if (!address) return '--';
  const toCheck = address?.building_number || address?.building_name;
  const checkLine1 = toCheck ? address.line_1.includes(toCheck) : true;
  return [
    checkLine1 ? undefined : address?.building_number || address?.building_name,
    address?.line_1,
    address?.line_2,
    address?.city,
    address?.postcode,
  ]
    .filter(Boolean)
    .join(', ');
};

export const formatBaseJobInfo = (job: Job): BaseJobInfo => ({
  customerName:
    [job?.customer?.first_name, job?.customer?.last_name]
      .filter(Boolean)
      .join(' ') || '--',
  customerEmail: job?.customer?.email || '--',
  customerPhone: job?.customer?.phone || '--',
  customerAddress: formatAddress(job?.customer?.address),
});

export const formatJobData = (jobs: Job[] | undefined): FormattedJob[] => {
  if (!jobs) return [];
  return jobs.map(
    (job: Job): FormattedJob => ({
      id: job?.id || '--',
      title: job.title,
      ...formatBaseJobInfo(job),
      createdAt: formatDate(
        job?.metadata?.created_at
          ? new Date(job.metadata.created_at)
          : undefined,
        'YYYY-MM-DD',
      ),
      updatedAt: formatDate(
        job?.metadata?.updated_at
          ? new Date(job.metadata.updated_at)
          : undefined,
        'YYYY-MM-DD',
      ),
    }),
  );
};
